module.exports = __webpack_public_path__ + "img/gift.064566b9.png";